import Vuex from "vuex"
import { buildAndMountApp } from "vue/core"
import App from "vue/turret_customizer/components/app.vue"
import TurretCustomizerModule from "vue/turret_customizer/module"
import { DEFAULT_CONVERSION_RATE } from "../vue/turret_customizer/module/constants"

const mountCustomizerComponent = () => {
  const host = document.getElementById("vueTurretCustomizer")
  if (!host) { return }

  const scopePlaceholderUrl = host.getAttribute("data-sticker-placeholder")
  const dataString = host.getAttribute("data-customization")

  const isAuthenticated = host.dataset.isAuthenticated === "true"
  const shouldShowNotes = host.dataset.showNotes === "true"

  const conversionRate = parseFloat(host.dataset.conversionRate) || DEFAULT_CONVERSION_RATE;

  const {
    ammunitions,
    current_scope: currentScope,
    current_brand: currentBrand,
    existing_customization: existingCustomization
  } = JSON.parse(dataString)

  const customizerModule = TurretCustomizerModule(ammunitions, currentScope, currentBrand, existingCustomization)
  const store = new Vuex.Store({modules: {turretCustomizer: customizerModule}})

  buildAndMountApp(host, App, store, {scopePlaceholderUrl, isAuthenticated, shouldShowNotes, currentScope, conversionRate})
}

document.addEventListener("turbolinks:load", mountCustomizerComponent)
document.addEventListener('DOMContentLoaded', mountCustomizerComponent)
